<template>

    <b-form-select :value="value ?? TaskDateOffsetUnit.calendarDays" :options="options"
        :disabled="disabled" @change="$emit('change', $event)" />

</template>

<script lang="ts">
import { Vue, Prop, Component } from "vue-property-decorator";
import { TaskDateOffsetUnit, taskDateOffsetUnitOptions } from "@/models/UserTask";

/**
 * Unit selector paired with a "days after creation" input on a template or scheduled task.
 * A null/undefined value shows as calendar days, matching how the server reads a missing unit.
 */
@Component({
    name: "TaskDateOffsetUnitSelect",
})
export default class TaskDateOffsetUnitSelect extends Vue {

    @Prop({ default: null }) value!: TaskDateOffsetUnit | null;
    @Prop({ default: false }) disabled!: boolean;

    protected TaskDateOffsetUnit = TaskDateOffsetUnit;
    protected options = taskDateOffsetUnitOptions;

}

</script>
